var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard_heading"},[_c('h1',[_vm._v("Hello, "+_vm._s(_vm.user.name))]),_c('p',[_vm._v("Welcome to your InsureCAREteams dashboard. What can we help you with?")])])}
var staticRenderFns = []

export { render, staticRenderFns }